import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_radio = _resolveComponent("el-radio");
    const _component_el_radio_group = _resolveComponent("el-radio-group");
    const _component_label_form = _resolveComponent("label-form");
    return (_openBlock(), _createBlock(_component_label_form, null, {
        default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
                modelValue: _ctx.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.value) = $event)),
                disabled: _ctx.disabled,
                class: _normalizeClass(_ctx.center ? 'align-items-center' : '')
            }, {
                default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_radio, {
                            key: index,
                            label: item.value,
                            border: !_ctx.borderless
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.label), 1 /* TEXT */)
                            ]),
                            _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label", "border"]));
                    }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue", "disabled", "class"])
        ]),
        _: 1 /* STABLE */
    }));
}
